import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cancelButton, primaryButton } from "./styles";

type Props = {
  open: boolean;
  name: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ApproveAllDialog({ open, name, onCancel, onConfirm }: Readonly<Props>) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="max-w-lg p-0 gap-0 bg-white-A700 rounded-lg">
        <DialogHeader className="px-8 pt-8 pb-6 text-left gap-2">
          <DialogTitle className="text-xl font-bold text-black-label">
            Approve {name}?
          </DialogTitle>
          <DialogDescription className="text-base text-[#4B5160]">
            This registers the business and can&apos;t be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="px-8 py-5 flex-row justify-end gap-2.5 rounded-b-lg bg-gray-button-gray-lite">
          <button type="button" className={cancelButton} onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className={primaryButton} onClick={onConfirm}>
            Approve
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
